import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./toggleButton.component.html",
})
export class FormlyToggleButton extends FieldType<FieldTypeConfig> {
    onLabel: string = "Complete";
    offLabel: string = "Incomplete";
    onIcon: string = "pi pi-check";
    offIcon: string = "pi pi-times";

    ngOnInit() {
        if (this.props.onLabel) this.onLabel = this.props.onLabel;

        if (this.props.offLabel) this.offLabel = this.props.offLabel;

        if (this.props.onIcon) this.onIcon = this.props.onIcon;

        if (this.props.offIcon) this.offIcon = this.props.offIcon;
    }

    change($event) {
        if (this.props.change) this.props.change(this);
    }
}
